"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headers = exports.Response = exports.Request = exports.fetch = void 0;
var tslib_1 = require("tslib");
var fetch_ponyfill_1 = tslib_1.__importDefault(require("fetch-ponyfill"));
var GLOBAL = typeof window !== 'undefined' ? window : global;
var isReactNative = GLOBAL.navigator && GLOBAL.navigator.product === 'ReactNative';
var ponyfill = isReactNative ? {
    fetch: GLOBAL.fetch,
    Request: GLOBAL.Request,
    Response: GLOBAL.Response,
    Headers: GLOBAL.Headers
} : fetch_ponyfill_1.default();
exports.fetch = ponyfill.fetch, exports.Request = ponyfill.Request, exports.Response = ponyfill.Response, exports.Headers = ponyfill.Headers;
if (typeof window !== 'undefined') {
    window.fetch = exports.fetch;
}
//# sourceMappingURL=ponyfill.js.map